import React from "react";
import { useIntl } from "react-intl";

/**
 * react-intl v7+ removed the `injectIntl` HOC in favor of the `useIntl` hook.
 * This shim preserves the legacy HOC call shape for pre-existing code that
 * hasn't been refactored yet: `export default injectIntl(MyComponent)`.
 *
 * @template P
 * @param {React.ComponentType<P & { intl: import('react-intl').IntlShape }>} Component
 * @returns {React.FC<P>}
 */
export function injectIntl(Component) {
  function WithIntl(props) {
    const intl = useIntl();
    return <Component {...props} intl={intl} />;
  }
  WithIntl.displayName = `injectIntl(${Component.displayName || Component.name || "Component"})`;
  return WithIntl;
}
